/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const deliveryZoneSchema = z.object({
	name: z.string(),
	coordinates: z.array(z.array(z.number()).min(2).max(2)).describe("Вершины зоны: пары [широта, долгота]."),
});
